import { render, staticRenderFns } from "./MainTips.vue?vue&type=template&id=b8e9ad9a&scoped=true"
import script from "./MainTips.vue?vue&type=script&lang=js"
export * from "./MainTips.vue?vue&type=script&lang=js"
import style0 from "./MainTips.vue?vue&type=style&index=0&id=b8e9ad9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e9ad9a",
  null
  
)

export default component.exports